// Rundown → CSV export. Extracted from the old Header so the TopBar (and any
// future caller) can trigger a download without duplicating the escaping/in-time
// logic. Column order + in-time anchoring mirror what the operator sees on screen.
import { computeInTimes } from './rundownDerive.js';

// CSV helpers — keep escaping simple and RFC-4180 safe.
function csvCell(value) {
  if (value == null) return '';
  const s = String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

function formatDurationMMSS(seconds) {
  if (seconds == null || seconds === '') return '';
  const s = Number(seconds);
  if (isNaN(s)) return '';
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

function formatHMS(date) {
  if (!date) return '';
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${h}:${m}:${s}`;
}


export function exportCuesAsCsv(show, cues) {
  if (!show || !cues || cues.length === 0) return;
  const sorted = [...cues].sort((a, b) => a.order - b.order);
  const inTimes = computeInTimes(sorted, show);
  const headers = [
    'Order', 'Label', 'Type', 'Duration', 'Time In', 'Time Out',
    'Script', 'Notes', 'TR Logo', 'BR Logo', 'Other GFX',
  ];
  const lines = [headers.map(csvCell).join(',')];
  sorted.forEach((cue, idx) => {
    const timeIn = inTimes[idx];
    const timeOut = timeIn
      ? new Date(timeIn.getTime() + (cue.planned_duration || 0) * 1000)
      : null;
    lines.push([
      idx + 1,
      cue.label || '',
      cue.cue_type || '',
      formatDurationMMSS(cue.planned_duration),
      formatHMS(timeIn),
      formatHMS(timeOut),
      cue.script || '',
      cue.notes || '',
      cue.top_right_logo || '',
      cue.bottom_right_logo || '',
      cue.other_graphics || '',
    ].map(csvCell).join(','));
  });
  // BOM keeps Excel happy with UTF-8 characters
  const csv = '﻿' + lines.join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const safeName = (show?.name || 'rundown').replace(/[^a-z0-9-_ ]/gi, '_').trim() || 'rundown';
  const stamp = new Date().toISOString().slice(0, 10);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${safeName}-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
